<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
           
            <el-card class="box-card">
                <el-table :data="SEOs" style="width: 100%">
                    
                    
                     <el-table-column label="title En">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>

              

                    <el-table-column label="title Ar" >
                        <template #default="scope">
                           <div class="">
                               {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                           </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="description En">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').description}}
                        </template>
                    </el-table-column>

              

                    <el-table-column label="description Ar" >
                        <template #default="scope">
                           <div class="">
                               {{$getLocaleData(scope.row.translates,'ar_sa').description}}
                           </div>
                        </template>
                    </el-table-column>
                    
                  

              

                    <el-table-column label="Operations" width="100" align="right">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit seo"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditSEO(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    computed:{
        cachedSEOs(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.seos?.list || []
        },
    },
    data(){
        return{
            SEOs:[],
            SEOStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedSEOs?.length){
            this.getAllSEOs();
        }else{
            this.SEOs = this.cachedSEOs;
          
        }
        
       
    },
    
    methods:{
       
        async getAllSEOs(){
            const response = await this.$store.dispatch('getAllSEOs');

            this.SEOs = [response];
             
        },
        
      
        async handleEditSEO(SEO){
            await this.$store.dispatch('storeCurrentSEOToView',SEO)
            this.$router.push({
                name:'manage-seo',
                params:{
                    id:SEO.id
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>